import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getDuplicatesGroupsTotal, getDuplicatesListCount, getDuplicatesListSize } from 'reactApp/modules/duplicates/duplicates.selectors';

interface IDuplicatesAnalytic {
    groups_count: number;
    size_files?: number;
    count_files?: number;
}

export const useDuplicatesAnalytic = (): IDuplicatesAnalytic => {
    const duplicatesGroupTotalCount = useSelector(getDuplicatesGroupsTotal);
    const duplicatesListSize = useSelector(getDuplicatesListSize);
    const duplicatesListCount = useSelector(getDuplicatesListCount);

    return useMemo(() => {
        const res: IDuplicatesAnalytic = { groups_count: duplicatesGroupTotalCount };

        if (duplicatesListSize > 0) {
            res.size_files = duplicatesListSize;
        }

        if (duplicatesListCount > 0) {
            res.count_files = duplicatesListCount;
        }

        return res;
    }, [duplicatesGroupTotalCount, duplicatesListSize, duplicatesListCount]);
};
